export function elementIsCtaButton(element) {
    if (typeof element != 'object' || element == null)
        return false;
    if ('title' in element && 'target' in element && 'type' in element) {
        return element.type == 'ctaButton';
    }
    return false;
}
